<template>
    <div class="order-tracking-view" >
        <b-card v-if="data !== null && data.data !== null">
            <b-table stacked :items="orderHeaderData" :fields="orderHeaderFields" caption-top>
                <template v-slot:table-caption>{{ data.data.orderId }} Numaralı sipariş detayları.</template>
                <template v-slot:cell(createDate)="rowData">
                    {{ rowData.item.createDate | moment('DD/MM/YYYY') }}
                </template>
                
            </b-table>
            <b-table striped hover :items="orderItemData" :fields="orderItemFields" caption-top>
                <template v-slot:table-caption>Siparişe ait ürünler.</template>
                <template v-slot:cell(createDate)="rowData">
                    {{ rowData.item.createDate | moment('DD/MM/YYYY') }}
                </template>
                <template v-slot:cell(estimatedShippingDate)="rowData">
                    {{ rowData.item.estimatedShippingDate | moment('DD/MM/YYYY') }}
                </template>         
                <template v-slot:cell(invoiceDate)="rowData">
                    {{ invoiceDate(rowData.item.invoiceDate)  | moment('DD/MM/YYYY') }}
                </template>          
                <template v-slot:cell(quantity)="rowData">
                    {{ parseFloat(rowData.item.quantity) }}
                </template>         
                
            </b-table>
        </b-card>
        <b-card v-if="data !== null && !data.success" bg-variant="danger" text-variant="white" class="text-center">
            <b-card-text><v-icon name="exclamation-circle"/> {{ data.message }}</b-card-text>
        </b-card>
    </div>
</template>

<script>
export default {
    name: 'OrderStatusView',
    props: {
        data: Object
    },
    methods: {
        invoiceDate(date)
        {
            if(date == '2000-01-01T00:00:00Z')
                return '-';
            return date;
        }
    },
    computed: {
        orderHeaderFields() {
            return [
                { key: 'createDate', label: 'Sipariş Tarihi' },
                { key: 'createTime', label: 'Sipariş Saati' },
                { key: 'orderLastStatusText', label: 'Sipariş Durumu' },
                { key: 'deliveryUnitText', label: 'Çıkış Yeri' },
                { key: 'deliveryMethod', label: 'Teslimat Şekli' },
                { key: 'description', label: 'Müşteri Sipariş Açıklaması' },
            ];
        },
        orderHeaderData() {
            return [
                this.data.data
            ];
        },
        orderItemFields() {
            return [
                { key: 'code', label: 'Ürün Kodu' },
                { key: 'description', label: 'Açıklama' },
                { key: 'quantity', label: 'Miktar' },
                { key: 'unit', label: 'Birim' },
                { key: 'estimatedShippingDate', label: 'Tahmini Çıkış Tarihi' },
                { key: 'invoiceDate', label: 'Fatura Tarihi' },
                { key: 'invoiceTime', label: 'Fatura Saati' },
            ];
        },
        orderItemData() {
            return this.data.data.items;
        }
    }
}
</script>

<style scoped>

</style>